'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_config$FetchConfig(prestoUrl, eventRouterUrl) {
  this.K8 = null;
  this.K7 = null;
  this.K8 = prestoUrl;
  this.K7 = eventRouterUrl;
}
export { $c_Lpresto_config$FetchConfig as $c_Lpresto_config$FetchConfig };
$p = $c_Lpresto_config$FetchConfig.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_config$FetchConfig;
/** @constructor */
function $h_Lpresto_config$FetchConfig() {
}
export { $h_Lpresto_config$FetchConfig as $h_Lpresto_config$FetchConfig };
$h_Lpresto_config$FetchConfig.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_config$FetchConfig) && ((this.K8 === x$0.K8) && (this.K7 === x$0.K7))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "FetchConfig";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.K8;
  }
  if ((n === 1)) {
    return this.K7;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_config$FetchConfig(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iZ)));
}
export { $isArrayOf_Lpresto_config$FetchConfig as $isArrayOf_Lpresto_config$FetchConfig };
var $d_Lpresto_config$FetchConfig = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_config$FetchConfig, "presto.config$FetchConfig", ({
  iZ: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_config$FetchConfig as $d_Lpresto_config$FetchConfig };
//# sourceMappingURL=presto.config$-Fetch-Config.js.map
